import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


export const SEARCH_PRODUCTS_API = Symbol('SEARCH_PRODUCTS_API')

export class SearchProductsGetRequest {
  endpointUrl: URL
  method = 'GET' as const
  headers: HeadersInit = { Accept: 'application/json' }
  controller: AbortController = new AbortController()

  constructor(endpoint: string) {
    this.endpointUrl = new URL(endpoint, window.location.href)
  }
}

export interface SearchProductsAPI {
  search(request: SearchProductsGetRequest): Promise<SearchResponse>
}

export interface SearchResponse {
  body: unknown
}

@registerDependency(FAKE, SEARCH_PRODUCTS_API)
export class FakeSearchProductsAPI implements SearchProductsAPI {
  requests: SearchProductsGetRequest[] = []
  searchShouldResolveInstantly: boolean = true
  resolveSearchResponse!: () => void
  responsePromise: Promise<void> = new Promise(resolve => this.resolveSearchResponse = resolve)
  searchData: { [key: string]: unknown } = {}

  async search(request: SearchProductsGetRequest): Promise<SearchResponse> {
    this.requests.push(request)

    // This is for testing such that the fake network request pauses untill you tell it to return
    // allowing you to test all kinds of things that might happen during the call.
    if (!this.searchShouldResolveInstantly) {
      await this.responsePromise
      this.responsePromise = new Promise(resolve => this.resolveSearchResponse = resolve)
    }

    const result  = {
      body : this.searchData[request.endpointUrl.search]
    }

    if (request.controller.signal.aborted) {
      throw new Error('request aborted')
    }

    return Promise.resolve(result)
  }
}

@registerDependency(REAL, SEARCH_PRODUCTS_API)
export class RealSearchProductsAPI implements SearchProductsAPI {
  async search(request: SearchProductsGetRequest): Promise<SearchResponse> {
    const response = await fetch(request.endpointUrl, {
      method: request.method,
      headers: request.headers,
      signal: request.controller.signal
    })
    return Promise.resolve({ body: await response.json() })
  }
}
